import { GW_PATH } from '../constants'

const NEXON_HOMEPAGE = 1

class LocalKRPC {
  constructor({
    memberAccessCode, useSimpleSignup, ial, mainUrl, loginUrl, logoutUrl, memberUrl, ssoUrl, ssoCode,
  }) {
    this.path = 'nxlogin'
    this.memberAccessCode = memberAccessCode || NEXON_HOMEPAGE
    this.useSimpleSignup = useSimpleSignup ?? false
    this.ial = ial

    this.mainUrl = mainUrl || 'https://www.nexon.com/Home/Game'
    this.loginUrl = loginUrl || 'https://nxlogin.nexon.com'
    this.logoutUrl = logoutUrl || 'https://login.nexon.com'
    this.memberUrl = memberUrl || 'https://member.nexon.com'

    this.signoutPath = '/login/page/logout.aspx?redirect='
    this.signupPath = `/join/join.aspx?accesscode=${this.memberAccessCode}&redirect=`
    this.accountPath = '/home/index.aspx'

    const ssoParams = new URLSearchParams({
      credentialCode: ssoCode,
      memberAccessCode: this.memberAccessCode,
      fallbackUrl: this.fallbackUrl,
    })
    this.ssoUrl = ssoUrl || 'https://join.nexon.com'
    this.ssoSigninPath = `/nk/page/v2/signin/credential?${ssoParams.toString()}&redirectUrl=`
  }

  get signinUrl() {
    const authLevelParam = this.ial ? 'authLevel=1&' : '' // 콘솔 링킹 시 1.0 가입 태우기 위해
    const signupParam = this.useSimpleSignup ? 'signup=1&' : '' // 간편가입 사용 시 signup=1 쿼리 추가
    return `${this.loginUrl}/auth/login?${authLevelParam}${signupParam}accesscode=${this.memberAccessCode}&redirect=`
  }

  get signoutUrl() {
    return this.logoutUrl + this.signoutPath
  }

  get signupUrl() {
    return this.memberUrl + this.signupPath
  }

  get accountUrl() {
    return this.memberUrl + this.accountPath
  }

  get ssoSigninUrl() {
    return this.ssoUrl + this.ssoSigninPath
  }

  // eslint-disable-next-line class-methods-use-this
  get fallbackUrl() {
    return `${window.location.origin}${GW_PATH.REDIRECT}?response=fail&code=-13`
  }
}

export default LocalKRPC
